import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import JoditEditor from "jodit-react";
import { IDS } from "../../../utils/common";
import Select from "react-select";

library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [country, setCountry] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [crop, setCrop] = useState([]);
  const [collectionCenter, setCollectionCenter] = useState([]);
  const GetAllCountry = async () => {
    const response = await getData("/common/masters/all-country");
    if (response?.success) {
      setCountry(await Select2Data(response?.data, "country_id"));
    }
  };
  const GetAllStates = async (id) => {
    const response = await getData(`/common/masters/all-state/${id}`);
    if (response?.success) {
      setStates(await Select2Data(response?.data, "state_id"));
    }
  };

  const GetAllCities = async (id) => {
    const response = await getData(`/common/masters/all-city/${id}`);
    if (response?.success) {
      setCities(await Select2Data(response?.data, "city_id"));
    }
  };
  const GetAllCrop = async () => {
    const response = await getData("/common/masters/all-crops");
    if (response?.success) {
      setCrop(await Select2Data(response?.data, "crop_id"));
    }
  };
  const GetAllCollectionCenter = async () => {
    const response = await getData("/common/masters/all-collection-center");
    if (response?.success) {
      setCollectionCenter(
        await Select2Data(response?.data, "collection_center_id")
      );
    }
  };

  useEffect(() => {
    GetAllCountry();
    GetAllCollectionCenter();
    GetAllCrop();
    // GetAllCities();
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    trigger,
    control,
    formState: { errors },
    image_required = true,
    setValue,
    clearErrors,
  } = useForm();
  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();
      finalData.append("name", data?.name);
      finalData.append("description", data?.description);
      finalData.append("contact_no", data?.contact_no);
      finalData.append("email", data?.email);
      finalData.append("address", data?.address);
      finalData.append("aadhar_no", data?.aadhar_no);
      // finalData.append("image", data?.image[0]);
      finalData.append("ac_no", data?.ac_no);
      finalData.append("ifsc_code", data?.ifsc_code);
      finalData.append("land", data?.land);
      // finalData.append("farmer_id", data?.farmer_id?.value);
      finalData.append("country_id", data?.country_id?.value);
      finalData.append("state_id", data?.state_id?.value);
      finalData.append("city_id", data?.city_id?.value);
      finalData.append(
        "collection_center_id",
        data?.collection_center_id?.value
      );
      finalData.append("crop_id", data?.crop_id?.value);
      if (data?.images && data?.images.length > 0) {
        for (let i = 0; i < data.images.length; i++) {
          finalData.append("images", data.images[i]);
        }
      }
      const response = await postData(`/admin/masters/farmer`, finalData);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [imagePreviews, setImagePreviews] = useState([]);
  const handleImagesChange = (e) => {
    const files = e.target.files;
    if (files) {
      const previews = [];
      Array.from(files).forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          previews.push(reader.result);
          if (previews.length === files.length) {
            setImagePreviews(previews);
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };
  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Farmer
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Farmer</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Farmer"
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required: "Farmer is required",
                            validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>
              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Description</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Controller
                          name="description"
                          control={control}
                          rules={
                            {
                              // required: "Content is required.",
                              // maxLength: {
                              //   value: 600,
                              //   message:
                              //     "content must be at most 600 characters long.",
                              // },
                            }
                          } // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("description");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                      </InputGroup>
                      {errors.description && (
                        <span className="text-danger">
                          {errors.description.message}
                        </span>
                      )}
                    </Form.Group>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Form.Group className="mb-3" controlId="formBasicName">
                          <Form.Label>Contact No</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Contact No."
                            className={classNames("", {
                              "is-invalid": errors?.contact_no,
                            })}
                            {...register("contact_no", {
                              required: "contact_no is required",
                              maxLength: {
                                value: 100,
                                message:
                                  "contact_no cannot exceed 100 characters",
                              },
                            })}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            maxLength={10}
                          />
                          {errors?.contact_no && (
                            <Form.Text className="text-danger">
                              {errors?.contact_no?.message}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Email"
                          className={classNames("", {
                            "is-invalid": errors?.email,
                          })}
                          {...register("email", {
                            required: "email is required",
                            maxLength: {
                              value: 100,
                              message: "email cannot exceed 100 characters",
                            },
                            pattern: {
                              value:
                                /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/,
                              message: "Enter a valid email address",
                            },
                          })}
                        />
                        {errors?.email && (
                          <Form.Text className="text-danger">
                            {errors?.email?.message}
                          </Form.Text>
                        )}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Address"
                          className={classNames("", {
                            "is-invalid": errors?.address,
                          })}
                          {...register("address", {
                            required: "address is required",
                            maxLength: {
                              value: 100,
                              message: "address cannot exceed 100 characters",
                            },
                          })}
                        />
                        {errors?.address && (
                          <Form.Text className="text-danger">
                            {errors?.address?.message}
                          </Form.Text>
                        )}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Form.Label>Aadhar Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Aadhar Number"
                          className={classNames("", {
                            "is-invalid": errors?.aadhar_no,
                          })}
                          {...register("aadhar_no", {
                            required: "aadhar_no is required",
                            maxLength: {
                              value: 100,
                              message: "aadhar_no cannot exceed 100 characters",
                            },
                          })}
                        />
                        {errors?.aadhar_no && (
                          <Form.Text className="text-danger">
                            {errors?.aadhar_no?.message}
                          </Form.Text>
                        )}
                      </div>
                    </Col>

                    <Form.Group
                      className="form-field mb-3"
                      controlId="formBasicEmail"
                    >
                      <Form.Label>Images</Form.Label>
                      <Form.Control
                        type="file"
                        name="images"
                        multiple
                        placeholder="Image"
                        className={classNames("", {
                          "is-invalid": errors?.images,
                        })}
                        {...register("images", {
                          // required: "Images is required",
                        })}
                        accept="image/*"
                        onChange={handleImagesChange}
                      />
                      {errors.images && (
                        <span className="text-danger">
                          {errors.images.message}
                        </span>
                      )}
                      <div className="img-row-holder">
                        {imagePreviews &&
                          imagePreviews.map((image, index) => {
                            return (
                              <div className="mt-2 mx-3" key={index}>
                                <img
                                  src={image}
                                  alt={`Category Preview ${index}`}
                                  style={{ maxWidth: "100px" }}
                                />
                              </div>
                            );
                          })}
                      </div>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className="text-center">
                        Image Preview
                      </Form.Label>
                      {typeof getValues("image") == "string" ? (
                        <div className="image-preview-container">
                          <img
                            src={IDS.IMG_URL + getValues("image")}
                            alt="Preview"
                            className="image-preview"
                            style={{ width: "150px", height: "130px" }}
                          />
                        </div>
                      ) : (
                        imageFile &&
                        imageFile?.length > 0 && (
                          <div className="image-preview-container">
                            <img
                              // src={URL.createObjectURL(getValues("image")[0])}
                              src={URL?.createObjectURL(imageFile[0])}
                              alt="Preview"
                              className="image-preview"
                              style={{ width: "100px", height: "100px" }}
                            />
                          </div>
                        )
                      )}
                    </Form.Group>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Form.Label>Account Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Account Number"
                          className={classNames("", {
                            "is-invalid": errors?.ac_no,
                          })}
                          {...register("ac_no", {
                            required: "ac_no is required",
                            maxLength: {
                              value: 100,
                              message: "ac_no cannot exceed 100 characters",
                            },
                          })}
                        />
                        {errors?.ac_no && (
                          <Form.Text className="text-danger">
                            {errors?.ac_no?.message}
                          </Form.Text>
                        )}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Form.Label>IFSC Code</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter IFSC Code"
                          className={classNames("", {
                            "is-invalid": errors?.ifsc_code,
                          })}
                          {...register("ifsc_code", {
                            required: "ifsc_code is required",
                            maxLength: {
                              value: 100,
                              message: "ifsc_code cannot exceed 100 characters",
                            },
                          })}
                        />
                        {errors?.ifsc_code && (
                          <Form.Text className="text-danger">
                            {errors?.ifsc_code?.message}
                          </Form.Text>
                        )}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Form.Label>Land </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Land"
                          className={classNames("", {
                            "is-invalid": errors?.land,
                          })}
                          {...register("land", {
                            required: "land is required",
                            maxLength: {
                              value: 100,
                              message: "land cannot exceed 100 characters",
                            },
                          })}
                        />
                        {errors?.land && (
                          <Form.Text className="text-danger">
                            {errors?.land?.message}
                          </Form.Text>
                        )}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Country</Form.Label>

                          <Controller
                            name="country_id" // name of the field
                            {...register("country_id", {
                              required: "Select Country",
                            })}
                            control={control}
                            render={({ field }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors.country_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={country}
                                onChange={(selectedOption) => {
                                  field.onChange(selectedOption.value); // Update Controller's value
                                  GetAllStates(selectedOption.value);
                                  setValue("country_id", selectedOption);
                                  setValue("state_id", null);
                                  setValue("city_id", null);
                                  clearErrors("country_id");
                                }}
                              />
                            )}
                          />

                          {errors.country_id && (
                            <span className="text-danger">
                              {errors.country_id.message}
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>State</Form.Label>

                          <Controller
                            name="state_id" // name of the field
                            {...register("state_id", {
                              required: "Select State",
                            })}
                            control={control}
                            render={({ field }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors.state_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={states}
                                onChange={(selectedOption) => {
                                  field.onChange(selectedOption.value); // Update Controller's value
                                  GetAllCities(selectedOption.value);
                                  setValue("state_id", selectedOption);
                                  setValue("city_id", null);
                                  clearErrors("state_id");
                                }}
                              />
                            )}
                          />

                          {errors.state_id && (
                            <span className="text-danger">
                              {errors.state_id.message}
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>City</Form.Label>

                          <Controller
                            name="city_id" // name of the field
                            {...register("city_id", {
                              required: "Select City",
                            })}
                            control={control}
                            render={({ field }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors.city_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={cities}
                              />
                            )}
                          />

                          {errors.city_id && (
                            <span className="text-danger">
                              {errors.city_id.message}
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Crop</Form.Label>

                          <Controller
                            name="crop_id" // name of the field
                            {...register("crop_id", {
                              required: "Select Crop",
                            })}
                            control={control}
                            render={({ field }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors.crop_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={crop}
                              />
                            )}
                          />

                          {errors.crop_id && (
                            <span className="text-danger">
                              {errors.crop_id.message}
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Collection Center</Form.Label>

                          <Controller
                            name="collection_center_id" // name of the field
                            {...register("collection_center_id", {
                              required: "Select Crop",
                            })}
                            control={control}
                            render={({ field }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors.collection_center_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={collectionCenter}
                              />
                            )}
                          />

                          {errors.collection_center_id && (
                            <span className="text-danger">
                              {errors.collection_center_id.message}
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
